import { LocalStorage } from 'shared/helpers/localStorage';
import { LOCAL_STORAGE_KEYS } from 'dashboard/constants/localStorage';
import themeEventEmitter from 'shared/helpers/themeEventEmitter';

// Track previous theme for event emission
let previousTheme = null;

export const setColorTheme = (isOSOnDarkMode, source = 'system') => {
  const selectedColorScheme =
    LocalStorage.get(LOCAL_STORAGE_KEYS.COLOR_SCHEME) || 'auto';

  let newTheme;
  if (
    (selectedColorScheme === 'auto' && isOSOnDarkMode) ||
    selectedColorScheme === 'dark'
  ) {
    newTheme = 'dark';
    document.body.classList.add('dark');
    document.documentElement.style.setProperty('color-scheme', 'dark');
  } else {
    newTheme = 'light';
    document.body.classList.remove('dark');
    document.documentElement.style.setProperty('color-scheme', 'light');
  }

  // Emit theme change event if theme actually changed
  if (newTheme !== previousTheme) {
    themeEventEmitter.emitThemeChange(newTheme, previousTheme, source);
    previousTheme = newTheme;
  }
};
